const environment = {
    environment: process.env.NODE_ENV,
    wordpressDirectory: process.env.REACT_APP_WORDPRESS_SUBDIRECTORY
};

export default environment;